export class ContestSubmissionsSummaryModel {
    public id: number;
    public title: string;
    public designFileUrl: string;
    public createdOn: string;
    public createdBy: string;
    public description: string;
    public tags: Array<string>;
    public isVoted: boolean;
    public isVotingAllowed: boolean;
}



// WEBPACK FOOTER //
// ./src/models/contest/contest.submissions.summary.model.ts